import { useState, useEffect, useCallback } from 'react';
import { CONSENT_OPEN_EVENT, LEGACY_CONSENT_COOKIES, LEGACY_CONSENT_KEYS } from '../config/consent.js';
import { consentMode, readConsent, storeConsent } from '../utils/visitorTracking.js';

// The first-visit consent (IDD D-HP-SITE-027): asked until decided for the current statement
// version, reopened from the footer, every decision recorded through storeConsent.
export const useCookieConsent = () => {
  const [consent, setConsent] = useState(() => readConsent());
  const [showConsentModal, setShowConsentModal] = useState(false);

  useEffect(() => {
    LEGACY_CONSENT_KEYS.forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch {
        // Storage may be blocked.
      }
    });
    LEGACY_CONSENT_COOKIES.forEach((name) => {
      document.cookie = `${name}=;path=/;max-age=0`;
    });
    if (!readConsent()) setShowConsentModal(true);
    const open = () => setShowConsentModal(true);
    window.addEventListener(CONSENT_OPEN_EVENT, open);
    return () => window.removeEventListener(CONSENT_OPEN_EVENT, open);
  }, []);

  const saveConsent = useCallback((choice, lang) => {
    setConsent(storeConsent(choice, lang));
    setShowConsentModal(false);
  }, []);

  const acceptAll = useCallback((lang) => saveConsent({ statistics: true, marketing: true }, lang), [saveConsent]);
  const rejectAll = useCallback((lang) => saveConsent({ statistics: false, marketing: false }, lang), [saveConsent]);
  // Closing without a choice is possible only when a decision already stands.
  const closeConsent = useCallback(() => {
    if (readConsent()) setShowConsentModal(false);
  }, []);

  return {
    cookieConsent: consent,
    consentMode: consentMode(consent),
    showConsentModal,
    saveConsent,
    acceptAll,
    rejectAll,
    closeConsent,
  };
};
